import { GET_SUBMISSION_DETAILS, GET_CASE_SUBMITTED_DETAILS } from '../types'

const INITIAL_STATE = {
  getAllSubmissionDeatails: [],
  submittedCaseDetails: {}
}

const SubmissionDetailsReducer = (state = INITIAL_STATE, { type, payload }) => {
  switch (type) {
    case GET_SUBMISSION_DETAILS:
      return {
        ...state,
        getAllSubmissionDeatails: payload.data,
        loader: false,
      }

    case GET_CASE_SUBMITTED_DETAILS:
      return {
        ...state,
        submittedCaseDetails: payload.data,
      }

    default:
      return state
  }
}

export default SubmissionDetailsReducer
